import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_STORAGE_KEY = "bi_admin_key";

api.interceptors.response.use(undefined, (error) => {
  const cfg = error?.config || {};
  const sentAdmin = cfg.headers && cfg.headers["X-Admin-Key"];
  if (error?.response?.status === 401 && sentAdmin && !String(cfg.url).includes("/admin/session")) {
    sessionStorage.removeItem(ADMIN_STORAGE_KEY);
    window.location.reload();
  }
  return Promise.reject(error);
});
